export default {
    RecACE:"RecACE",
    FIRSTRec:"FIRSTRec",
    User: "ユーザー管理",
    Permission:"権限管理",
    Device:"デバイス管理",
    Record:"録音音声一覧",
    Account:"アカウント管理",
    RecACEPlus:"RecACEplus設定",
    Category:"通話分類設定",
    ProperNoun:"固有名詞設定",
    ManualSetting: "RecACE設置マニュアル.pdf",
    ManualPlusUser: "RecACEplus利用マニュアル.pdf",
}